import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as actions from '../security-groups.actions';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { SecurityService } from 'src/app/core/security.service';

@Injectable()
export class SecurityEffect {
    getPostedJob$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadSecurityGroupsSecurity),
            switchMap((action) => {
                return this.securityService.getSecurityGroup(action.jobId).pipe(
                    map((response) =>
                        actions.loadSecurityGroupsSecuritySuccess({
                            security: response
                        })
                    ),
                    catchError((error: unknown) => of(actions.loadSecurityGroupsSecurityFail({ error })))
                );
            })
        );
    });

    getPostedJobFail$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(actions.loadSecurityGroupsSecurityFail),
                tap((action) => {
                    console.log(action.error);
                    this.toaster.toast('Sorry. A problem occurred while loading Job Details.');
                })
            );
        },
        { dispatch: false }
    );

    constructor(
        private readonly actions$: Actions,
        protected securityService: SecurityService,
        private readonly toaster: ToasterService
    ) {}
}
